module.exports = __webpack_public_path__ + "img/Pista_35.53e0ae7c.png";